import { translate } from "../../util/translate"

export const paymentHeader = [
  {
    text: translate['payment.list.label.name'],
    value: 'name',
    width: '300',
  },
  {
    text: translate['payment.list.label.username'],
    value: 'username',
    width: '300',
  },
  {
    text: translate['payment.list.label.city'],
    value: 'city',
    width: '200',
  },
  {
    text: translate['payment.list.label.total'],
    value: 'total',
    align: 'right',
    width: '180',
  },
  { value: 'actions', align: 'center', width: '75' },
]

export const invoiceHeader = [
  {
    text: translate['hostInvoices.headers.code'],
    value: 'code',
    sortable: false,
    width: '150',
  },
  {
    text: translate['hostInvoices.headers.transactionId'],
    value: 'transaction_id',
    sortable: false,
    width: '200',
  },
  {
    text: translate['hostInvoices.headers.createdAt'],
    value: 'date',
    sortable: false,
    width: '150',
  },
  {
    text: translate['hostInvoices.headers.description'],
    value: 'description',
    sortable: false,
    width: '150',
  },
  {
    text: translate['hostInvoices.headers.value'],
    value: 'value',
    sortable: false,
    align: 'right',
    width: '150',
  },
]
